const safeParse = (v) => {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isFinite(d.getTime()) ? d : null;
};

const DATE_OPTS = { day: "2-digit", month: "short", year: "numeric" };
const DT_OPTS = { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" };

export const safeDate = (v) => safeParse(v);

export const fmtDate = (v, locale = "en-IN") => {
  const d = safeParse(v);
  return d ? d.toLocaleDateString(locale, DATE_OPTS) : "—";
};

export const fmtDateTime = (v, locale = "en-IN") => {
  const d = safeParse(v);
  return d ? d.toLocaleString(locale, DT_OPTS) : "—";
};

export const fmtRelative = (v) => {
  const d = safeParse(v);
  if (!d) return "—";
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 30) return "just now";
  if (diff < 60 * 60) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 60 * 60 * 24) return `${Math.floor(diff / 3600)} h ago`;
  if (diff < 60 * 60 * 24 * 30) return `${Math.floor(diff / 86400)} d ago`;
  return fmtDate(v);
};

export const daysBetween = (a, b) => {
  const da = safeParse(a);
  const db = safeParse(b);
  if (!da || !db) return null;
  return Math.round((db.getTime() - da.getTime()) / (1000 * 60 * 60 * 24));
};

export const computeTrialEndFromCreation = (createdAt, trialDays) => {
  const d = safeParse(createdAt);
  if (!d || !Number.isFinite(trialDays) || trialDays <= 0) return null;
  return new Date(d.getTime() + trialDays * 24 * 60 * 60 * 1000);
};
